
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/license/[date]",
      function () {
        return require("private-next-pages/[locale]/license/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/license/[date]"])
      });
    }
  